export enum TimeUnit {
  /** Hour */
  Hour = 'H',
  /** Minute */
  Minute = 'Min',
  /** Second */
  Second = 'S',
  /** Day */
  Day = 'D',
  /** Week */
  Week = 'Wk',
  /** Month */
  Month = 'Mo',
  /** Year */
  Year = 'Yr',
  /** Quarter */
  Quarter = 'Q',
  EndOfMonth = 'EOM',
  Flexible = 'F',
}
